import MenuHeader from "../../common/MenuHeader"
import RightGoogleMap from "../../common/RightGoogleMap"
import SetUpLayout from "../../common/SetUpLayout"
import LayoutMain from "./LayoutMain"

type Props = {}

const Historical = (props: Props) => {
  return (
    <SetUpLayout
      title='Historical'

      header={
        <MenuHeader />
      }
      rightLayout={<RightGoogleMap style={{
        width: { xs: '488px' },
      }}
      />}
    >
      <LayoutMain title="Data 6 of 9" subtitle="Historical ET" />
    </SetUpLayout>
  )
}

export default Historical